<template>
  <div class="card-wrap">
    <p class="card-title">
      作为您的智能伙伴，拥有海量招标知识储备，我会尽可能的解答行业知识以及
    </p>
    <p class="card-tip">你可以试着问我:</p>
    <div class="card-list">
      <div class="card-list-item">招标流程是什么?</div>
      <div class="card-list-item">标书如何制作</div>
    </div>
    <div class="card-btn" @click="joinChat">进入智能问答</div>
  </div>
</template>

<script>
import utils from "@mixins/utils";

export default {
  mixins: [utils],
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    joinChat() {
      this.$store.dispatch("analysis/updateHits", {visitlocation: "首页-智能问答"});
      window.location.assign("/intelQueAnswer");
    },
  },
};
</script>

<style scoped lang="scss">
.card-wrap {
  padding: 23px 30px 34px 30px;
  border-radius: 8px;
  background: #FFFFFF;

  .card-title {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 26px;
    margin-bottom: 42px;
  }

  .card-tip {
    font-weight: 400;
    font-size: 16px;
    color: #3D7EFF;
    margin-bottom: 18px;
  }

  .card-list {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;

    &-item {
      width: 153px;
      height: 36px;
      line-height: 36px;
      background: #DFEAFF;
      border-radius: 3px;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
  }

  .card-btn {
    width: 153px;
    margin: 0 auto;
    height: 36px;
    line-height: 36px;
    background: #0E4EFF;
    border-radius: 3px;
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
  }
}
</style>

